module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABKUlEQVR4Ac2QA25EQRyH9yR7l16gcRWjtt0uotoIas28QW3btp1GvcHqt/aGxfOb+b6/VL9ymDc2YooXN06+zJGReIbFjWMlV7n3vxwCaBAuAd9wPLiHHPpYMzpTLg6cGcxmo9GIJwSz87DTGfQtB4LyOLFQVj824RTA2S+12vUNOl+5aRwb7ZzqmlgoTycf0BwCCvAqiZCaukUIhexyerG4enRWL7cy6Ws2fXJmaGsLz5xxCcWVy/ams5XHLPqCqlLJ5/iCpm500iEEGsjDxIKmcmQxcei7eVzwuara0WmN2AssIGQWfW6Z4DqxAxol1Y+Np5N3JAwgoND2CVI5sjC5WFY3NolKNGIftH03gIDYfdPt9aPjOrldxC5sY320bwUWQl+qf3lYAJH3NhNmcKB5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TV.png
// module id = 1287
// module chunks = 0